import { gql } from "@apollo/client";

export const GET_ESTADOS_DOCUMENTOS_SAP = gql`
query estadosDocumentoSap {
    estadosDocumentoSap {
        idEstadoDocumentoSap
        descripcion
    }
}`;
